import { Badge, Tab } from '@chakra-ui/react';
import { ComponentProps, FC } from 'react';

const selectedTabStyle = {
  bg: 'text.brand',
  color: 'white',
  borderTopRadius: '4px',
};

const tabStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  py: 3,
  whiteSpace: 'nowrap',
};

interface SidePaneTabProps extends Omit<
  ComponentProps<typeof Tab>,
  'children'
> {
  label: string;
  badge?: string;
}

export const SidePaneTab: FC<SidePaneTabProps> = ({
  label,
  badge,
  ...props
}) => {
  return (
    <Tab _selected={selectedTabStyle} sx={tabStyle} {...props}>
      {label}
      {badge && (
        <Badge
          colorScheme="green"
          fontSize="2xs"
          borderRadius="full"
          px={1.5}
          minW="18px"
          textAlign="center"
          data-testid="tab-badge"
        >
          {badge}
        </Badge>
      )}
    </Tab>
  );
};
